import { observer } from 'mobx-react'
import { WrappedComponentProps, injectIntl } from 'react-intl'
import ReportsItemDate from './ReportsItemDate'

import { DiscrepancyIndicator, models } from '@tfo/common'

import '../ReportsItem.scss'

export interface ReportsItemDeliveredProps {
	data: models.IGroupOrder
	onClick: any
	reportPackages: models.ReportPackage[]
	showCompanyName: boolean
}

const ReportsItemDelivered = ({
	data,
	intl,
	onClick,
	reportPackages,
	showCompanyName,
}: ReportsItemDeliveredProps & WrappedComponentProps) => (
	<div
		className={'ReportsItem ReportsItem--standard ReportsItem--active'}
		data-cy={'deliveredOrder'}
		id={'reportsItem_' + data.id.toString()}>
		<div className={'ReportsItem__Inner '} onClick={onClick}>
			{showCompanyName && (
				<div className={'ReportsItem__Cell'}>{data.orders[0].companyName}</div>
			)}
			<div className={'ReportsItem__Cell'}>
				{reportPackages.find(x => x.id === data.orders[0].servicePackageId)
					?.customName ?? ''}
			</div>
			<div className={'ReportsItem__Cell ReportsItem__Cell--centerAlign'}>
				{intl.formatMessage({ id: 'client.reports.item.grouporder' })}
			</div>
			<div className={'ReportsItem__Cell ReportsItem__Cell--centerAlign'}>
				{intl.formatMessage({ id: 'client.reports.item.amount' })}:&nbsp;
				{data.orders.length}
			</div>
			<div className={'ReportsItem__Cell ReportsItem__Cell--centerAlign'}></div>
			<ReportsItemDate
				date={data.orders[0].availableTo}
				label={intl.formatMessage({
					id: 'client.reports.item.labels.availableTo',
				})}
			/>
			{data.orders.some(o => o.reportSummary) && (
			<DiscrepancyIndicator
				title={intl.formatMessage({ id: 'common.reportWithDiscrepancy' })}
				body=""
				className='	ReportsItem__ReportSummary'
			/>
		)}
		</div>
		
	</div>
)
export default injectIntl(observer(ReportsItemDelivered))
